import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
interface AOR {
  id: string;
  name: string;
}

export interface DistributionList {
  id: string;
  name: string;
  description?: string;
  aor?: AOR | null;
  members?: UUID[];
  created_at: string;
  updated_at: string;
  type: 'functional' | 'ics';
}

export const useDistributionLists = (group_guid: string | undefined) => {
  return useQuery<DistributionList[], AxiosError>({
    queryKey: ['distributionLists', group_guid],
    queryFn: async () => {
      if (!group_guid) return [];

      try {
        const response = await axios.post<DistributionList[]>(
          config.apiGateway.fetchDistributionListByGroup,
          {
            group_guid,
          }
        );
        return response.data;
      } catch (error) {
        console.error('Error fetching distribution lists:', error);
        toast.error('Failed to fetch distribution lists.');
        throw error;
      }
    },
    retry: false,
  });
};
